export default __webpack_public_path__ + "static/media/uppsala_logo.fd10776f.svg";